import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isSchedulerLoggedOut } from '../../auth/schedulerSession';
import { LOGOUT_PATH } from '../../auth/logoutPaths';

/**
 * When logged out while inside the app shell, send user to /logout immediately.
 */
const SchedulerSessionGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const normalized = pathname.replace(/\/+$/, '') || '/';

  if (isSchedulerLoggedOut() && normalized !== LOGOUT_PATH) {
    return <Navigate to={LOGOUT_PATH} replace />;
  }

  return <>{children}</>;
};

export default SchedulerSessionGuard;
